import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./DrawerWrapper.scss";
import { IModalWrapper } from "../ModalWrapper/Interfaces";
export function DrawerWrapper(props: IModalWrapper) {
    const { children, title, onClose, submitButton, onSubmit, data } = props;
    const onClickIn = () => {
        if (onClose) {
            onClose(false)
        }
    }
    return (
        <>
            <div className="drawer-wrapper modal modal-drawer show d-block" tabIndex={1} id="modalWrapper" role="dialog" aria-labelledby="modalDrawerRight" aria-hidden="true" >
                <div className="modal-dialog modal-drawer-bottom display-size" role="document" >
                    <div className="modal-content">
                        {title !== "Device Log" &&
                            <div className="modal-header">
                                <div>
                                    <span id="header" className="modal-title w-100"> {title} </span>
                                    {data &&
                                        <p className="mt-2 mb-0">
                                            <b>{data?.message}  </b> Expiry Date :  &nbsp;
                                            {data?.data?.expiry_date}
                                        </p>
                                    }
                                </div>
                                <div className="font-icon" onClick={() => onClose && onClose(false)}>
                                    <FontAwesomeIcon icon={faTimes} className="mx-1 menu-link-hoverable pointer" data-dismiss="modal" />
                                </div>
                            </div>
                        }
                        {children}
                        {submitButton &&
                            <div className="no-border-footer modal-footer justify-content-center" >
                                <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mx-4 set-qc-button " onClick={onSubmit} >{submitButton}</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    )
}
export default DrawerWrapper;